import { Component } from 'react';
import {
  isRecoverableChunkError,
  recoverFromChunkError,
} from '../utils/chunkRecovery';

const ADMIN_EMBLEMS_RECOVERY_KEY = 'emblem:admin-emblems-data-recovery';
const ADMIN_EMBLEMS_CACHE_PREFIXES = [
  'admin_emblems_cache_',
  'admin_emblems_first_page_cache_',
];

const recoverFromAdminEmblemsDataError = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!window.location.pathname.startsWith('/admin/emblems')) {
    return false;
  }

  try {
    if (window.sessionStorage.getItem(ADMIN_EMBLEMS_RECOVERY_KEY) === '1') {
      return false;
    }

    window.sessionStorage.setItem(ADMIN_EMBLEMS_RECOVERY_KEY, '1');
    for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
      const key = window.sessionStorage.key(index);
      if (ADMIN_EMBLEMS_CACHE_PREFIXES.some((prefix) => key?.startsWith(prefix))) {
        window.sessionStorage.removeItem(key);
      }
    }
    window.location.reload();
    return true;
  } catch (_) {
    return false;
  }
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);

    if (recoverFromAdminEmblemsDataError()) {
      return;
    }

    recoverFromChunkError(error, 'global');
  }

  render() {
    if (this.state.hasError) {
      const isChunkError = isRecoverableChunkError(this.state.error);

      return (
        <div style={{ padding: '40px', textAlign: 'center', fontFamily: 'Montserrat, sans-serif' }}>
          <h1>Something went wrong</h1>
          <p>
            {isChunkError
              ? 'The page is updating. Reload the page to fetch the latest admin tools.'
              : 'Please refresh the page or try again later.'}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: '16px',
              borderRadius: '999px',
              border: '1px solid rgba(0,0,0,0.12)',
              padding: '10px 18px',
              background: '#111827',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
